<div class="modal-header">
	<h1 class="modal-title">{{ title }}</h1>
	<ae-modal-mover />
	<button
		class="btn btn-outline-dark"
		title="Close"
		type="button"
		(click)="activeModal.dismiss()"
	>
		<i aria-hidden="true" class="far fa-times"></i>
	</button>
</div>
<div class="modal-body">
	@if (form) {
		<ng-container [formGroup]="form">
			<div class="form-group">
				<label for="pagination.table.bulkSelect.modal.component.ids">
					Paste IDs to Select (one per line)
				</label>

				<textarea
					class="form-control"
					formControlName="ids"
					id="pagination.table.bulkSelect.modal.component.ids"
					rows="8"
					type="text"
				></textarea>
			</div>
			<div class="form-group">
				<div class="fw-bold mb-1">How should these IDs be applied?</div>
				<div class="form-check">
					<input
						class="form-check-input"
						formControlName="type"
						id="pagination.table.bulkSelect.modal.component.add"
						name="type"
						type="radio"
						value="add"
					/>
					<label
						class="form-check-label mb-0"
						for="pagination.table.bulkSelect.modal.component.add"
					>
						Add them to the current selections
					</label>
				</div>
				<div class="form-check">
					<input
						class="form-check-input"
						formControlName="type"
						id="pagination.table.bulkSelect.modal.component.replace"
						name="type"
						type="radio"
						value="replace"
					/>
					<label
						class="form-check-label mb-0"
						for="pagination.table.bulkSelect.modal.component.replace"
					>
						Replace the current selections
					</label>
				</div>
			</div>
		</ng-container>
	}
</div>
<div class="modal-footer">
	<button
		class="btn btn-secondary"
		id="pgtable.bulkSelect.cancel"
		type="button"
		(click)="activeModal.dismiss()"
	>
		Cancel
	</button>
	<button
		class="btn btn-primary"
		id="pgtable.bulkSelect.close"
		type="button"
		[disabled]="!form?.valid"
		(click)="close()"
	>
		Select
	</button>
</div>
